import React from 'react'
import { Badge, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'

export type SiteHealthProps = {
    health?: 'ok' | 'warning' | 'error'
}

export function SiteHealth({ health }: SiteHealthProps) {
    const { t } = useTranslation()

    if (!health) {
        return null
    }

    const status = { ok: 'success', warning: 'warning', error: 'error' } as const
    const label = {
        ok: t('Everything works'),
        warning: t('Needs attention'),
        error: t('Not working'),
    }

    return (
        <Tooltip title={label[health]}>
            <Badge
                status={status[health]}
                text={label[health]}
            />
        </Tooltip>
    )
}
